<div class="drawer-backdrop" *ngIf="open" (click)="onClose()"></div>
<section class="drawer" [class.open]="open">
    <header class="drawer__header">
        <div class="drawer__title">
            <span class="drawer__title-text">{{ 'aumico_user_notifications_title' | i18next }}</span>
        </div>
        <div class="drawer__actions">
            <span class="ham-icon envelope-open-outline icon-with-tooltip" (click)="onMarkAllAsRead()">
                <i class="envelope-open-outline-icon"></i>
                <span class="icon-tooltip">{{ 'aumico_user_notifications_mark_all_read' | i18next }}</span>
            </span>
            <span
                class="ham-icon filter-outline icon-with-tooltip"
                [class.selected]="filterOptionSelected"
                #filterBtnRef
                (click)="onOpenFilter($event)"
            >
                <i class="filter-outline-icon"></i>
                <span class="icon-tooltip">{{ 'aumico_user_notifications_filter' | i18next }}</span>
            </span>
            <span
                class="menu-flyout notification-filter-flyout"
                *ngIf="openedFlyout"
                [ngStyle]="{ top: flyoutPosition.top + 'px', left: flyoutPosition.left + 'px' }"
            >
                <div class="filter-flyout-content">
                    <div
                        *ngFor="let option of filterOptions"
                        class="filter-option"
                        (click)="onFilterChange(option.value)"
                        [class.selected]="option.value === filterOptionSelected"
                    >
                        <span class="ham-icon">
                            <i *ngIf="option.value === 'READ'" class="envelope-open-outline-icon"></i>
                            <i *ngIf="option.value === 'UNREAD'" class="envelope-outline-icon"></i>
                            <i *ngIf="option.value === 'ARCHIVED'" class="archive-outline-icon"></i>
                        </span>
                        <label style="cursor: pointer" (click)="onFilterChange(option.value)">{{ option.label | i18next }}</label>
                    </div>
                    <button class="filter-clear-btn" type="button" (click)="onFilterChange(undefined)">{{ 'aumico_user_notifications_clear_filter' | i18next }}</button>
                </div>
            </span>
            <button class="drawer__icon-btn" type="button" aria-label="Close" (click)="onClose()">✕</button>
        </div>
    </header>
    <div class="drawer__body">
        <ng-container *ngIf="!loading; else loadingTpl">
            <div *ngIf="notifications?.length === 0" class="drawer__empty">{{ 'aumico_user_notifications_empty' | i18next }}</div>
            <ng-container *ngFor="let group of grouped">
                <div class="drawer__section-title">{{ group.title }}</div>
                <ul class="drawer__list">
                    <li
                        *ngFor="let n of group.items"
                        class="drawer__item"
                        [class.unread]="!n.isRead"
                        [class.archived]="n.isArchived"
                    >
                        <div class="drawer__avatar-wrapper">
                            <div class="drawer__avatar">{{ getInitials(n.data.triggeredByUserName, n.type) }}</div>
                            <span class="drawer__bullet" [class.unread]="!n.isRead"></span>
                        </div>
                        <div class="drawer__content" (click)="onOpenNotificationAndMarkRead(n)">
                            <div class="drawer__line">
                                <span class="drawer__text" [innerHTML]="buildMessage(n)"></span>
                            </div>
                            <div class="drawer__meta" [class.unread]="!n.isRead">
                                {{ getDisplayTime(n.createdAt) }}
                            </div>
                        </div>
                        <div class="notification__actions" (click)="$event.stopPropagation()">
                            <span
                                class="ham-icon envelope-open-outline icon-with-tooltip"
                                (click)="markAsReadUnread(n); $event.stopPropagation()"
                            >
                                <i *ngIf="!n.isRead" class="envelope-open-outline-icon"></i>
                                <i *ngIf="n.isRead" class="envelope-outline-icon"></i>
                                <span class="icon-tooltip">{{ getReadStateTooltip(n) }}</span>
                            </span>
                            <span
                                class="ham-icon archive-outline icon-with-tooltip"
                                (click)="archiveNotification(n); $event.stopPropagation()"
                            >
                                <i class="archive-outline-icon"></i>
                                <span class="icon-tooltip">{{ getArchiveStateTooltip(n) }}</span>
                            </span>
                        </div>
                    </li>
                </ul>
            </ng-container>
        </ng-container>
        <ng-template #loadingTpl>
            <div class="drawer__loading">{{ 'aumico_user_notifications_loading' | i18next }}</div>
        </ng-template>
    </div>
</section>
